import React, { useState } from "react";
import { Form, Button, Alert } from "react-bootstrap";
import { useParams } from "react-router-dom";
import "./GameLogin.css";
import { useAuth } from "./AuthProvider";
import BackgroundImage from './welcome.jpg';

const locale_et = {
    label: "ET",
    messages: {
        "password": "Parool",
        "incorrect": "Vale parool",
        "logIn": "Logi sisse",
        "loggingIn": "Sisselogimine...",
    }
};
const locale_en = {
    label: "EN",
    messages: {
        "password": "Password",
        "incorrect": "Incorrect password",
        "logIn": "Log in",
        "loggingIn": "Loggin in...",
    }
};
const defaultLocale = locale_et;

const Login = () => {
  const auth = useAuth();
  const params = useParams();
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState();
  const [locale, setLocale] = useState(defaultLocale);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setError(undefined);
    let response = await auth.gameLoginAction({
        gameId: params.id,
        password: password,
    });
    if (response?.status === 403) {
        setError("Invalid password");
    }
    setLoading(false);
  };

  return (
    <div
      className="sign-in__wrapper"
      style={{ backgroundImage: `url(${BackgroundImage})` }}
    >
      <div className="sign-in__backdrop"></div>
      <Form className="shadow p-4 bg-white rounded" onSubmit={handleSubmit}>
          <Form.Group className="mb-2">
              <div className="w-100 mb-2 position-relative start-50 translate-middle-x text-center"><a href="." onClick={() => setLocale(locale_et)}>{locale_et.label}</a> | <a href="." onClick={() => setLocale(locale_en)}>{locale_en.label}</a>
              </div>
          </Form.Group>
        {error ? (
          <Alert
            className="mb-2"
            variant="danger"
            onClose={() => setError(undefined)}
            dismissible
          >
            {locale.messages.incorrect}
          </Alert>
        ) : (
          <div />
        )}
        <Form.Group className="mb-2" controlId="password">
          <Form.Label>{locale.messages.password}</Form.Label>
          <Form.Control
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </Form.Group>
        {!loading ? (
          <Button className="w-100" variant="primary" type="submit">
            {locale.messages.logIn}
          </Button>
        ) : (
          <Button className="w-100" variant="primary" type="submit" disabled>
            {locale.messages.loggingIn}
          </Button>
        )}
      </Form>
      <div className="w-100 mb-2 position-absolute bottom-0 start-50 translate-middle-x text-white text-center">
        FactoryLab | 2026
      </div>
    </div>
  );
};

export default Login;
